<picture *ngIf="img"
         [ngClass]="pictureClass ?? ''"
>
  <ng-container *ngFor="let src of srcSet">
    <ng-container *ngIf="src?.mediaQuery">
      <source *ngIf="img.lazyLoad && !src?.noWebp"
              [attr.lazyLoad]="getImageUrlWebP(src)"
              [media]="src?.mediaQuery"
              type="image/webp"
      >
      <source *ngIf="img?.lazyLoad"
              [attr.lazyLoad]="getImageUrl(src)"
              [media]="src?.mediaQuery"
              type="image/jpeg"
      >
      <source *ngIf="!img.lazyLoad && !src?.noWebp"
              [media]="src?.mediaQuery"
              [srcset]="getImageUrlWebP(src)"
              type="image/webp"
      >
      <source *ngIf="!img.lazyLoad"
              [media]="src?.mediaQuery"
              [srcset]="getImageUrl(src)"
              type="image/jpeg"
      >
    </ng-container>
  </ng-container>
  <img [alt]="img?.altText || ''"
       [attr.data-cy]="dataCy"
       [attr.data-loaded]="dataLoaded"
       [attr.data-placeholder-background]="dataPlaceholderBackground"
       [class]="imgClass || 'img-responsive'"
       [lazyLoad]="img?.lazyLoad ? img?.xl : undefined"
       [src]="img?.lazyLoad ? undefined : img?.xl"
       [width]="width || img?.width || undefined"
       [height]="height || img?.height || undefined"
  />
  <ng-content></ng-content>
</picture>
